import { NgModule, isDevMode, ErrorHandler } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { IonicStorageModule } from "@ionic/storage-angular";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ServiceWorkerModule } from "@angular/service-worker";
import Bugsnag from "@bugsnag/js";
import { BugsnagErrorHandler } from "@bugsnag/plugin-angular";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { UserState } from "./state-man/state/user.state";
import * as myGlobals from './globals';
import { ISPCStoreState } from "./state-man/state/ispc-store.state";
import { AppConfigState } from "./state-man/state/app-config.state";
import { AppState } from "./state-man/state/app.state";
import { ExpenseTypeState } from "./state-man/state/expense-type.state";
import { environment } from '../environments/environment';
import { TimeEntryState } from "./state-man/state/time-entry.state";
import { ExpenseEntryState } from "./state-man/state/expense-entry.state";
import { ProjectTypeState } from "./state-man/state/project-type.state";
import { ConfigState } from "./state-man/state/config.state";

// configure Bugsnag asap
Bugsnag.start({ 
  apiKey: '45cb74e975298e7280bea29302c8889a',
  appVersion: myGlobals.app_version,
  releaseStage: environment.env === 'prod' ? 'production' : environment.env?.toLowerCase()
});

// create a factory which will return the Bugsnag error handler
export function errorHandlerFactory() {
  return new BugsnagErrorHandler();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    IonicModule.forRoot({
      swipeBackEnabled: false
    }),
    NgxsModule.forRoot([
      AppConfigState,
      UserState,     
      ISPCStoreState,      
      AppState,    
      ExpenseTypeState,
      TimeEntryState,
      ExpenseEntryState,
      ProjectTypeState,
      ConfigState
    ], {      
      developmentMode: isDevMode()
    }),
    NgxsStoragePluginModule.forRoot({
      key: ['user','app_config'],
      namespace: 'rw3'
    }),
    /*
    // Helps debug state changes (log to console state changes):
    NgxsLoggerPluginModule.forRoot(),    
    NgxsReduxDevtoolsPluginModule.forRoot({
      disabled: !isDevMode()
    }),
    */
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    // AutoCompleteModule,
    IonicStorageModule.forRoot(),
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: "registerWhenStable:30000",
    }),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useFactory: errorHandlerFactory },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
